import { useEffect, useMemo, useState } from "react";
import "./FileViewer.css";

const readParam = (key) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key) || "";
};

const FileViewer = () => {
  const src = useMemo(() => readParam("src"), []);
  const name = useMemo(() => readParam("name") || "File", []);

  const [lines, setLines] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = name;
  }, [name]);

  useEffect(() => {
    if (!src) {
      setLoading(false);
      setError("File URL is missing.");
      return;
    }
    let cancelled = false;
    fetch(src)
      .then(async (resp) => {
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
        return resp.text();
      })
      .then((text) => {
        if (cancelled) return;
        const split = (text || "").split(/\r?\n/);
        setLines(split);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || "Failed to load file.");
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [src]);

  const onDownload = () => {
    if (!src) return;
    const a = document.createElement("a");
    a.href = src;
    a.download = name || "file";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="fv-root">
      <div className="fv-header" title={name}>
        <span className="fv-title">{name}</span>
      </div>
      <div className="fv-body">
        {loading && <div className="fv-loading">Loading…</div>}
        {!loading && error && <div className="fv-error">{error}</div>}
        {!loading && !error && lines && (
          <div className="fv-text">
            {lines.length === 0 || (lines.length === 1 && !lines[0]) ? (
              <p className="fv-empty">File is empty.</p>
            ) : (
              lines.map((ln, i) => <p key={i}>{ln || " "}</p>)
            )}
          </div>
        )}
      </div>
      <div className="fv-footer">
        <button
          type="button"
          className="fv-btn fv-btn-primary"
          onClick={onDownload}
          disabled={!src}
        >
          Download
        </button>
      </div>
    </div>
  );
};

export default FileViewer;
